import { ConnectionRightHistory } from '@shared/interfaces/nts/connection-right';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { DecimalCellComponent } from '@shared/components/table/cells/decimal-cell/decimal-cell.component';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { DATE_TIME_FORMAT } from '@app/core/constants/date-time-format';

const commonColumns: TableConfig<ConnectionRightHistory>['columns'] = [
  {
    title: 'connectionRight.validFrom',
    key: 'validFrom',
    cellRenderer: DateCellComponent,
  },
  {
    title: 'connectionRight.changedAt',
    key: 'modified',
    cellRenderer: DateCellComponent,
    cellRendererParams: { format: DATE_TIME_FORMAT },
  },
  {
    title: 'connectionRight.comment',
    key: 'comment',
  },
  {
    title: 'connectionRight.changedBy',
    key: 'modifiedBy',
  },
];

export const connectionRightHistoryTable: TableConfig<ConnectionRightHistory> = {
  pagination: false,
  columnSelection: false,
  resize: false,
  disableSorting: true,
  columns: [
    {
      title: 'connectionRight.maximumPower',
      key: 'maximumPower',
      cellRenderer: DecimalCellComponent,
    },
    {
      title: 'connectionRight.maximumCurrent',
      key: 'maximumCurrent',
      cellRenderer: DecimalCellComponent,
    },
    {
      title: 'connectionRight.limitedGridAccess',
      key: 'limitedGridAccess',
      cellRenderer: DecimalCellComponent,
    },
    {
      title: 'connectionRight.limitedGridAccessCurrent',
      key: 'limitedGridAccessCurrent',
      cellRenderer: DecimalCellComponent,
    },
    ...commonColumns,
  ],
};
